import {
	coverageByID,
	coverageCreate,
	coverageDestroy,
	coverageList,
	coverageUpdate,
} from '@/services/agency/coverages.service'

export default {
	namespaced: true,
	state: {
		// SERVICE COVERAGE
		coverageList: {
			meta: {
				pagination: {
					total: 0,
				},
			},
		},
		coverage: {},

		// STATUS SERVICE COVERAGE
		coverageStatus: 'pending',
		coverageSaveStatus: 'init',
		coverageDeleteStatus: 'init',
	},
	getters: {
		// SERVICE COVERAGE
		getCoverageList(state) {
			return state.coverageList
		},
		getCoverage(state) {
			return state.coverage
		},

		// SERVICE STATUS
		getStatusList(state) {
			return state.statusList
		},
		getStatus(state) {
			return state.status
		},

		// SERVICE COVERAGE
		getCoverageDeleteStatus(state) {
			return state.coverageDeleteStatus
		},
		getCoverageSaveStatus(state) {
			return state.coverageSaveStatus
		},
		getCoverageStatus(state) {
			return state.coverageStatus
		},
	},
	mutations: {
		// SERVICE COVERAGE
		COVERAGE_LIST(state, value) {
			state.coverageList = value
		},
		SET_COVERAGE(state, value) {
			state.coverage = value
		},

		// STATUS SERVICE COVERAGE
		COVERAGE_STATUS(state, value) {
			state.coverageStatus = value
		},
		COVERAGE_SAVE_STATUS(state, value) {
			state.coverageSaveStatus = value
		},
		COVERAGE_DELETE_STATUS(state, value) {
			state.coverageDeleteStatus = value
		},
	},
	actions: {
		// Service Coverage
		async fetchCoverageList({ commit }, params) {
			window.scrollTo({ top: 0, behavior: 'smooth' })
			commit('COVERAGE_STATUS', 'pending')
			commit('COVERAGE_LIST', {
				meta: {
					pagination: {
						total: 0,
					},
				},
			})
			try {
				const { data } = await coverageList(params)
				commit('COVERAGE_STATUS', 'init')
				commit('COVERAGE_LIST', data)
				return data
			} catch (error) {
				commit('COVERAGE_STATUS', 'init')
				throw error
			}
		},
		async fetchCoverageByID({ commit }, params) {
			commit('COVERAGE_STATUS', 'pending')
			try {
				const { data } = await coverageByID(params)
				commit('COVERAGE_STATUS', 'init')
				commit('SET_COVERAGE', data.data)
				return data
			} catch (error) {
				commit('COVERAGE_STATUS', 'init')

				return error
			}
		},
		async saveNewCoverage({ commit }, params) {
			commit('COVERAGE_SAVE_STATUS', 'pending')
			try {
				const { data } = await coverageCreate(params)
				commit('COVERAGE_SAVE_STATUS', 'init')
				return data
			} catch (error) {
				commit('COVERAGE_SAVE_STATUS', 'init')
				throw error
			}
		},
		async updateCoverage({ commit }, params) {
			commit('COVERAGE_SAVE_STATUS', 'pending')
			try {
				const { data } = await coverageUpdate(params)
				commit('COVERAGE_SAVE_STATUS', 'init')
				return data
			} catch (error) {
				commit('COVERAGE_SAVE_STATUS', 'init')
				throw error
			}
		},
		async deleteCoverageByID({ commit }, params) {
			commit('COVERAGE_DELETE_STATUS', 'pending')
			try {
				const { data } = await coverageDestroy(params)
				commit('COVERAGE_DELETE_STATUS', 'init')
				return data
			} catch (error) {
				commit('COVERAGE_DELETE_STATUS', 'error')

				return error
			}
		},
	},
}
